export { TelemonitoringReportCard } from './ReportCard';
